import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { fromEvent, Observable, Subject } from 'rxjs';
import { WebcamInitError, WebcamImage, WebcamUtil } from 'ngx-webcam';

import { LoggerService } from 'src/app/core/services/logger.service';
import { RegistrationService } from 'src/app/registration/shared/registration.service';
import { DocumentImage } from 'src/app/registration/shared/models/document-image.model';
import { debounceTime } from 'rxjs/operators';

const BACK_CAMERA_LABEL = 'facing back';

@Component({
    selector: 'app-webcam-snapshot',
    templateUrl: './webcam-snapshot.component.html',
    styleUrls: ['./webcam-snapshot.component.scss'],
    standalone: false
})
export class WebcamSnapshotComponent implements OnInit {

  @Input() isFrontImage = false;
  @Input() isBackImage = false;
  @Input() isSelfieImage = false;
  @Output() imageTaken: EventEmitter<DocumentImage> = new EventEmitter<DocumentImage>();
  width: number;
  height: number;
  showWebcam = true;
  backCameraDeviceId;

  allowCameraToSwitch = true;
  deviceId: string;
  // latest snapshot
  webcamImage: WebcamImage;

  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();
  // webcam snapshot trigger
  trigger: Subject<void> = new Subject<void>();

  constructor(private loggerService: LoggerService) {
    fromEvent(window, 'resize')
    .pipe(debounceTime(300))
    .subscribe((event) => {
      this.resize(event);
    });
    this.resize();
  }

  ngOnInit() {
    this.selectDefaultCamera();
  }

  onRetryImage() {
    this.webcamImage = undefined;
    this.selectDefaultCamera();
  }

  onSaveImage() {
    this.showWebcam = false;
    const documentImage = new DocumentImage();
    documentImage.image = this.webcamImage;
    this.imageTaken.emit(documentImage);
  }

  onCameraSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  onInitError(error: WebcamInitError): void {
    this.loggerService.log(error.message);
  }

  onImageCapture(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
  }

  resize(event?: Event) {
    const win = !!event ? (event.target as Window) : window;
    this.width = .67; // win.innerWidth;
    this.height = .67; // win.innerHeight;
  }

  showNextWebcam(directionOrDeviceId: boolean|string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  onTriggerSnapshot(): void {
    this.trigger.next();
  }

  selectDefaultCamera() {
    WebcamUtil.getAvailableVideoInputs()
    .then((mediaDevices: MediaDeviceInfo[]) => {
      const multiWebcamsAvailable = mediaDevices && mediaDevices.length > 1;

      // If there is more than 1 camera, set back camera as defaul if it's not a selfie.
      if (multiWebcamsAvailable && !this.isSelfieImage) {
        mediaDevices.forEach((device: MediaDeviceInfo) => {
          if (device.label.indexOf(BACK_CAMERA_LABEL) !== -1) {
            this.backCameraDeviceId = device.deviceId;
          }
        });

        if (this.backCameraDeviceId) {
          this.showNextWebcam(this.backCameraDeviceId);
        }
      }
    });
  }

  public get nextWebcamObservable(): Observable<boolean|string> {
    return this.nextWebcam.asObservable();
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

}
